import {handleResponse, authHeader} from '../helpers';
const BASE_URL = process.env.REACT_APP_API_URL;
export const salesAreaService = {
	getAll,
	getSuburbGeom
}

function getSuburbGeom(postcodes) {
	const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	};
	return fetch(BASE_URL + `/suburb-geom/${encodeURI(postcodes)}`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}

function getAll() {
	const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	};
	return fetch(BASE_URL + `/salesarea/all`, requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}